var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgJobsFilled = function SvgJobsFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 20 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M15.627 2.5a2.71 2.71 0 0 1 2.708 2.708v4.584a2.71 2.71 0 0 1-2.708 2.708h-.625v.625a2.71 2.71 0 0 1-2.709 2.708H8.914l-3.609 2.005a.624.624 0 0 1-.928-.546v-1.459a2.71 2.71 0 0 1-2.709-2.708V8.542a2.71 2.71 0 0 1 2.709-2.709h.833v-.625A2.71 2.71 0 0 1 7.918 2.5zM6.46 5.833h5.833a2.71 2.71 0 0 1 2.709 2.709v2.708h.625c.805 0 1.458-.653 1.458-1.458V5.208c0-.805-.653-1.458-1.458-1.458H7.918c-.805 0-1.458.653-1.458 1.458z",
    clipRule: "evenodd"
  })));
};
export default SvgJobsFilled;